import React from 'react';
import './PeriodDistribution.css';

/**
 * Enhanced PeriodDistribution component with theme support
 * Shows the proportion of events across different match periods
 */
const PeriodDistribution = ({ periodEvents, totalEvents }) => {
    return (
        <div className="stats-section">
            <h3 className="stats-section-title">Period Distribution</h3>
            <div className="period-stats">
                {Object.entries(periodEvents).map(([period, count]) => (
                    <div key={period} className="period-stat">
                        <div className="period-name">{period}</div>
                        <div className="period-count">{count} events</div>
                        <div className="period-percentage">
                            {totalEvents ? Math.round((count / totalEvents) * 100) : 0}%
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PeriodDistribution;